<template>
  <q-panel class="login-page">
    <div class="login-header">
      <img
        :src="logo"
        alt="Atrvasa"
        width="200px"
      >
    </div>
    <h4> REGISTER </h4>
    <div class="login-form">
      <q-form
        ref="loginForm"
        :model="ruleForm"
        :rules="rules"
        label-position="right"
        labq-width="120px"
      >
        <q-form-item
          prop="username"
        >
          <q-input
            v-model="ruleForm.username"
            :placeholder="this.$qt('loginPage.username')"
          />
        </q-form-item>
        <q-form-item
          prop="password"
        >
          <q-input
            v-model="ruleForm.password"
            type="password"
            :placeholder="this.$qt('loginPage.password')"
          />
        </q-form-item>
        <q-form-item
          prop="phone"
        >
          <q-input
            v-model="ruleForm.phone"
            :placeholder="this.$qt('registerPage.phone')"
          />
        </q-form-item>
        <q-form-item>
          <q-button
            size="mini"
            type="primary"
            style="width: 100%"
            @click="register"
          >
            {{ this.$qt('registerPage.register') }}
          </q-button>
        </q-form-item>
      </q-form>
    </div>
  </q-panel>
</template>

<script>
  import logo from '../../assets/images/logo-40.png';
  import icon from '../../assets/images/icon-30.jpg';

  export default {
    name: "ResetPassword",

    data() {
      return {
        logo: logo,
        icon: icon,
        ruleForm: {
          username: '',
          password: '',
          phone: '',
          email: ''
        },
        rules: {
          username: [
            {required: true, message: this.$qt('loginPage.usernameValidation.required'), trigger: 'blur'},
          ],
          password: [
            {required: true, message: this.$qt('loginPage.passwordValidation.required'), trigger: 'blur'}
          ]
        },
      };
    },

    created() {
    },

    methods: {
      initialize() {
      },

      register() {

      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize());
    }
  };
</script>

<style scoped>
  .login-page {
    text-align: center;
    background-color: #ebebeb;
    width: 300px;
    height: 400px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    border-radius: 5px;
  }

  .login-header {
    border-bottom: 1px solid #303133;
    padding: 15px;
    margin-bottom: 25px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .login-form {
    margin: 25px;
  }
</style>
